<template>
  <div>
    <nav class="uk-navbar-container" uk-navbar>
      <div style="width: 960px; margin-left: auto; margin-right: auto; display: flex;">
      <div class="uk-navbar-left">
        <ul class="uk-navbar-nav">
          <li>
              <a href="/"><h2>NESC.NU</h2></a>
          </li>
        </ul>
      </div>

      <div class="uk-navbar-right">
        <ul class="uk-navbar-nav">
          <li v-for="page in pages" v-bind:key="page.slug">
            <router-link
              :to="{ path: '/' + page.slug }"
              :key="page.slug"
            >
              {{ page.name }}
            </router-link>
          </li>
          <li class="router-link-exact-active router-link-active" v-if='!auth'>
            <router-link to="/register">Registrer bruker</router-link>
          </li>
          <li class="router-link-exact-active router-link-active" v-if='!auth'>
            <router-link to="/login">Logg inn</router-link>
          </li>
          <li class="router-link-exact-active router-link-active" v-if='auth' @click="onLogout">
            <a href="">Logg ut</a>
          </li>
          <li class="router-link-exact-active router-link-active" v-if='auth'>
            <router-link to="/new-article">+Ny artikkel</router-link>
          </li>
        </ul>
      </div>
      </div>
    </nav>
  </div>
</template>
<style scoped>
nav {
  background-color: #ece8e1 !important;
}
h2 {
  margin-top: 20px;
}
</style>
<script>
import gql from "graphql-tag";

export default {
  computed: {
    auth () {
      return this.$store.getters.ifAuthenticated
    }
  },
  name: "Nav",
  data() {
    return {
      pages: []
    };
  },
  apollo: {
    pages: gql`
      query Pages {
        pages {
          name
          slug
        }
      }
    `
  },
      methods: {
      onLogout() {
        this.$store.dispatch('logout')
      }
    }
};
</script>